<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose">
      <el-timeline v-if="list && list.length>0">
        <el-timeline-item v-for="(item,index) in list" v-bind:key="index" color="#0bbd87" :timestamp="item.createTime"
                          placement="top">
          <el-card>
            <h4>{{ item.title }}</h4>
            <p class="content-item" v-for="(itemRemark,index) in item.remark" v-bind:key="index">{{
                itemRemark.name
              }}:{{ itemRemark.value }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <span v-else>无数据</span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  components: {},
  props: {
    id: {
      type: String,
      require: true
    },
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onOpen() {
      const _this = this
      if (_this.id) {
        _this.$common.my_ajax({
          url: '/traceabilityItem/pageTraceabilityItem',
          data: {
            limit: -1,
            type: 'PRODUCE',
            traceabilityId: _this.id
          },
          success: function (response) {
            _this.list = (response.items || []).map((item) => {
              if (item && item.remark) {
                item.remark = JSON.parse(item.remark)
              }
              return item
            });
          }
        });
      }
    },
    onClose() {
    },
    close() {
      this.list = []
      this.$emit('update:id', '')
      this.$emit('update:type', '')
      this.$emit('update:visible', false)
    },
  }
}

</script>
<style>
.content-item {
  margin: 2px;
  color: #909399;
}
</style>
